var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.632,
    height: 12,
    viewBox: "0 0 12.632 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".filled{fill:#a7a5a5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M6.316,1.5C2.833,1.5,0,4.05,0,7.184a5.255,5.255,0,0,0,1,3.075,4.908,4.908,0,0,1-.942,2.882A.211.211,0,0,0,.21,13.5l.029,0a11.254,11.254,0,0,0,3.5-1.124,6.854,6.854,0,0,0,2.577.494c3.483,0,6.316-2.55,6.316-5.684S9.8,1.5,6.316,1.5Z",
    transform: "translate(0 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFilled);
export default __webpack_public_path__ + "static/media/chat-filled.c988cd42e64a4d42fdae6f3801181e0b.svg";
export { ForwardRef as ReactComponent };